import { Component, EventEmitter, Input, ViewEncapsulation, Output, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { FournisseurService } from '../../services/fournisseur.service';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FilterCriteria } from '../../models/filter-criteria.model';

@Component({
  selector: 'fs-filters',
  styleUrls: ['./filters.sass'],
  templateUrl: './filters.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FiltreRechercheComponent implements OnDestroy {
  @Input() pageName: string;
  @Output() filterCriteriaChange: EventEmitter<FilterCriteria> = new EventEmitter();

  filterCriteria = new FilterCriteria();
  filterNumPieceSubj = new Subject<string>();
  filterNumPieceObs = this.filterNumPieceSubj.asObservable();

  filterDateDebutSubj = new Subject<string>();
  filterDateDebutObs = this.filterDateDebutSubj.asObservable();

  filterDateFinSubj = new Subject<string>();
  filterDateFinObs = this.filterDateFinSubj.asObservable();

  faSearch = faSearch;
  faTimes = faTimes;

  dateDebut: string;
  dateFin: string;
  numPiece: string;

  subscriptions: Subscription[] = [];
  subscriptionFourniseur: Subscription;
  subscriptionDateDebut: Subscription;
  subscriptionDateFin: Subscription;
  subscriptionNumPiece: Subscription;

  constructor(private fournisseurService: FournisseurService) {
    this.subscriptionFourniseur = this.fournisseurService.activeSupplierChange$.subscribe
      (fournisseur => this.clearNumPiece());

    this.subscriptionNumPiece = this.filterNumPieceObs.pipe(debounceTime(1500), distinctUntilChanged()).subscribe(
      term => {
        this.filterCriteria.numPiece = term;
        this.filterCriteriaChange.emit(this.filterCriteria);
      });

    this.subscriptionDateDebut = this.filterDateDebutObs.pipe(debounceTime(1500), distinctUntilChanged()).subscribe(term => {
      this.filterCriteria.dateDebut = term;
      this.filterCriteriaChange.emit(this.filterCriteria);
    });

    this.subscriptionDateFin = this.filterDateFinObs.pipe(debounceTime(1500), distinctUntilChanged()).subscribe(term => {
      this.filterCriteria.dateFin = term;
      this.filterCriteriaChange.emit(this.filterCriteria);
    });

    this.subscriptions.push(this.subscriptionFourniseur, this.subscriptionNumPiece, this.subscriptionDateDebut, this.subscriptionDateFin);
  }

  private clearNumPiece() {
    this.numPiece = '';
    this.filterCriteria.numPiece = '';
  }

  clearFilter(filterName: string) {
    switch (filterName) {
      case 'dateDebut':
        this.dateDebut = '';
        this.filterDateDebutSubj.next(null);
        break;
      case 'dateFin':
        this.dateFin = '';
        this.filterDateFinSubj.next(null);
        break;
      case 'numPiece':
        this.numPiece = '';
        this.filterNumPieceSubj.next(null);
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
